// QrCodeGenerator.js
//
// Self-contained, dependency-free QR code generator. Produces an SVG data-URI
// from an arbitrary text string entirely in-browser — nothing leaves the page.
//
// Used by NativeCryptoDisplay to render an EIP-681 `payment_uri` as a scannable
// QR (chain + token + recipient + exact amount) without calling any external
// QR-image web service (privacy: the payment_uri must not leave the browser).
//
// Implementation: a compact byte-mode QR encoder supporting versions 1-10 with
// automatic version selection at error-correction level M. This covers the
// length of EIP-681 URIs comfortably (~250+ alphanumeric chars at version 10).

// --- Galois field (GF(256)) tables for Reed-Solomon error correction ---
var EXP = new Array(256);
var LOG = new Array(256);
(function () {
  var x = 1;
  for (var i = 0; i < 255; i++) {
    EXP[i] = x;
    LOG[x] = i;
    x <<= 1;
    if (x & 0x100) x ^= 0x11d;
  }
  for (var j = 255; j < 256; j++) EXP[j] = EXP[j - 255];
})();

function gfMul(a, b) {
  if (a === 0 || b === 0) return 0;
  return EXP[(LOG[a] + LOG[b]) % 255];
}

function rsGeneratorPoly(degree) {
  var poly = [1];
  for (var i = 0; i < degree; i++) {
    var next = new Array(poly.length + 1).fill(0);
    for (var j = 0; j < poly.length; j++) {
      next[j] ^= gfMul(poly[j], EXP[i]);
      next[j + 1] ^= poly[j];
    }
    poly = next;
  }
  return poly;
}

function rsEncode(data, ecLen) {
  var gen = rsGeneratorPoly(ecLen);
  var res = new Array(ecLen).fill(0);
  for (var i = 0; i < data.length; i++) {
    var factor = data[i] ^ res[0];
    res.shift();
    res.push(0);
    for (var j = 0; j < ecLen; j++) {
      res[j] ^= gfMul(gen[j], factor);
    }
  }
  return res;
}

// --- Per-version capacity tables for EC level M (byte mode) ---
// [version] => { size, ecPerBlock, group1Blocks, group1DataCw, group2Blocks, group2DataCw, totalDataCw, alignment }
var VERSIONS = {
  1: { ec: 10, g1: 1, d1: 16, g2: 0, d2: 0, align: [] },
  2: { ec: 16, g1: 1, d1: 28, g2: 0, d2: 0, align: [6, 18] },
  3: { ec: 26, g1: 1, d1: 44, g2: 0, d2: 0, align: [6, 22] },
  4: { ec: 18, g1: 2, d1: 32, g2: 0, d2: 0, align: [6, 26] },
  5: { ec: 24, g1: 2, d1: 43, g2: 0, d2: 0, align: [6, 30] },
  6: { ec: 16, g1: 4, d1: 27, g2: 0, d2: 0, align: [6, 34] },
  7: { ec: 18, g1: 4, d1: 31, g2: 0, d2: 0, align: [6, 22, 38] },
  8: { ec: 22, g1: 2, d1: 38, g2: 2, d2: 39, align: [6, 24, 42] },
  9: { ec: 22, g1: 3, d1: 36, g2: 2, d2: 37, align: [6, 26, 46] },
  10: { ec: 26, g1: 4, d1: 43, g2: 1, d2: 44, align: [6, 28, 50] },
};

function versionSize(v) {
  return 17 + v * 4;
}

function totalDataCodewords(spec) {
  return spec.g1 * spec.d1 + spec.g2 * spec.d2;
}

function chooseVersion(byteLen) {
  for (var v = 1; v <= 10; v++) {
    var spec = VERSIONS[v];
    var cap = totalDataCodewords(spec);
    // header: mode(4) + length(8 for v1-9, 16 for v10) + terminator
    var charCountBits = v <= 9 ? 8 : 16;
    var needBits = 4 + charCountBits + byteLen * 8;
    if (needBits <= cap * 8) return v;
  }
  throw new Error("QR: data too long");
}

// --- Bit buffer ---
function BitBuffer() {
  this.bits = [];
}
BitBuffer.prototype.put = function (val, len) {
  for (var i = len - 1; i >= 0; i--) {
    this.bits.push((val >>> i) & 1);
  }
};

function buildDataCodewords(text, version, spec) {
  var bytes = [];
  for (var i = 0; i < text.length; i++) {
    var c = text.charCodeAt(i);
    if (c < 0x80) {
      bytes.push(c);
    } else if (c < 0x800) {
      bytes.push(0xc0 | (c >> 6), 0x80 | (c & 0x3f));
    } else {
      bytes.push(0xe0 | (c >> 12), 0x80 | ((c >> 6) & 0x3f), 0x80 | (c & 0x3f));
    }
  }
  var bb = new BitBuffer();
  bb.put(4, 4); // byte mode
  var charCountBits = version <= 9 ? 8 : 16;
  bb.put(bytes.length, charCountBits);
  for (var b = 0; b < bytes.length; b++) bb.put(bytes[b], 8);

  var cap = totalDataCodewords(spec) * 8;
  // terminator
  var term = Math.min(4, cap - bb.bits.length);
  bb.put(0, term);
  // pad to byte boundary
  while (bb.bits.length % 8 !== 0) bb.bits.push(0);
  // pad bytes
  var pads = [0xec, 0x11];
  var pi = 0;
  while (bb.bits.length < cap) {
    bb.put(pads[pi % 2], 8);
    pi++;
  }
  // to codewords
  var cw = [];
  for (var k = 0; k < bb.bits.length; k += 8) {
    var v = 0;
    for (var j = 0; j < 8; j++) v = (v << 1) | bb.bits[k + j];
    cw.push(v);
  }
  return cw;
}

function interleave(dataCw, version, spec) {
  // split into blocks
  var blocks = [];
  var idx = 0;
  for (var i = 0; i < spec.g1; i++) {
    blocks.push(dataCw.slice(idx, idx + spec.d1));
    idx += spec.d1;
  }
  for (var k = 0; k < spec.g2; k++) {
    blocks.push(dataCw.slice(idx, idx + spec.d2));
    idx += spec.d2;
  }
  var ecBlocks = blocks.map(function (b) {
    return rsEncode(b, spec.ec);
  });
  var maxData = Math.max(spec.d1, spec.d2 || 0);
  var result = [];
  for (var col = 0; col < maxData; col++) {
    for (var bi = 0; bi < blocks.length; bi++) {
      if (col < blocks[bi].length) result.push(blocks[bi][col]);
    }
  }
  for (var c2 = 0; c2 < spec.ec; c2++) {
    for (var bi2 = 0; bi2 < ecBlocks.length; bi2++) {
      result.push(ecBlocks[bi2][c2]);
    }
  }
  return result;
}

// --- Matrix construction ---
function buildMatrix(allCw, version, spec) {
  var size = versionSize(version);
  var m = [];
  var reserved = [];
  for (var r = 0; r < size; r++) {
    m.push(new Array(size).fill(null));
    reserved.push(new Array(size).fill(false));
  }

  function setFn(r, c, val) {
    m[r][c] = val ? 1 : 0;
    reserved[r][c] = true;
  }

  // finder pattern
  function placeFinder(rr, cc) {
    for (var dr = -1; dr <= 7; dr++) {
      for (var dc = -1; dc <= 7; dc++) {
        var r = rr + dr,
          c = cc + dc;
        if (r < 0 || r >= size || c < 0 || c >= size) continue;
        var inRing =
          (dr >= 0 && dr <= 6 && (dc === 0 || dc === 6)) ||
          (dc >= 0 && dc <= 6 && (dr === 0 || dr === 6));
        var inCenter = dr >= 2 && dr <= 4 && dc >= 2 && dc <= 4;
        setFn(r, c, inRing || inCenter ? 1 : 0);
      }
    }
  }
  placeFinder(0, 0);
  placeFinder(0, size - 7);
  placeFinder(size - 7, 0);

  // timing patterns
  for (var t = 8; t < size - 8; t++) {
    setFn(6, t, t % 2 === 0 ? 1 : 0);
    setFn(t, 6, t % 2 === 0 ? 1 : 0);
  }

  // dark module
  setFn(size - 8, 8, 1);

  // alignment patterns
  var ap = spec.align;
  for (var ai = 0; ai < ap.length; ai++) {
    for (var aj = 0; aj < ap.length; aj++) {
      var ar = ap[ai],
        ac = ap[aj];
      // skip if overlaps a finder
      if (reserved[ar][ac]) continue;
      for (var ddr = -2; ddr <= 2; ddr++) {
        for (var ddc = -2; ddc <= 2; ddc++) {
          var isBorder = Math.max(Math.abs(ddr), Math.abs(ddc)) !== 1;
          setFn(ar + ddr, ac + ddc, isBorder ? 1 : 0);
        }
      }
    }
  }

  // reserve format info areas (filled later)
  for (var fi = 0; fi < 9; fi++) {
    if (!reserved[fi][8]) reserved[fi][8] = true;
    if (!reserved[8][fi]) reserved[8][fi] = true;
  }
  for (var fj = 0; fj < 8; fj++) {
    if (!reserved[8][size - 1 - fj]) reserved[8][size - 1 - fj] = true;
    if (!reserved[size - 1 - fj][8]) reserved[size - 1 - fj][8] = true;
  }

  // place data bits zigzag
  var bitStream = [];
  for (var ci = 0; ci < allCw.length; ci++) {
    for (var bj = 7; bj >= 0; bj--) bitStream.push((allCw[ci] >> bj) & 1);
  }
  var bitIdx = 0;
  var upward = true;
  for (var colp = size - 1; colp > 0; colp -= 2) {
    if (colp === 6) colp = 5; // skip timing column
    for (var rowi = 0; rowi < size; rowi++) {
      var row = upward ? size - 1 - rowi : rowi;
      for (var sub = 0; sub < 2; sub++) {
        var col = colp - sub;
        if (reserved[row][col]) continue;
        var bit = bitIdx < bitStream.length ? bitStream[bitIdx++] : 0;
        m[row][col] = bit;
      }
    }
    upward = !upward;
  }

  // apply mask 0 ((r+c)%2==0) on non-reserved modules
  for (var mr = 0; mr < size; mr++) {
    for (var mc = 0; mc < size; mc++) {
      if (reserved[mr][mc]) continue;
      if ((mr + mc) % 2 === 0) m[mr][mc] ^= 1;
    }
  }

  // format info: EC level M (bits 00) + mask 0 (000) => data 00000
  // standard precomputed format string for (M, mask 0):
  var formatBits = 0x5412; // BCH-encoded format info for EC=M, mask=0
  for (var k2 = 0; k2 < 15; k2++) {
    var b = (formatBits >> k2) & 1;
    // around top-left
    if (k2 < 6) m[k2][8] = b;
    else if (k2 === 6) m[7][8] = b;
    else if (k2 === 7) m[8][8] = b;
    else if (k2 === 8) m[8][7] = b;
    else m[8][14 - k2] = b;
    // mirrored copy
    if (k2 < 8) m[8][size - 1 - k2] = b;
    else m[size - 15 + k2][8] = b;
  }

  return m;
}

// --- public API: text -> SVG data URI ---
function qrToSvgDataUri(text, opts) {
  opts = opts || {};
  var margin = opts.margin == null ? 4 : opts.margin;
  var dark = opts.dark || "#000000";
  var light = opts.light || "#ffffff";

  var byteLen = 0;
  for (var i = 0; i < text.length; i++) {
    var c = text.charCodeAt(i);
    byteLen += c < 0x80 ? 1 : c < 0x800 ? 2 : 3;
  }
  var version = chooseVersion(byteLen);
  var spec = VERSIONS[version];
  var dataCw = buildDataCodewords(text, version, spec);
  var allCw = interleave(dataCw, version, spec);
  var m = buildMatrix(allCw, version, spec);
  var size = m.length;
  var dim = size + margin * 2;

  var rects = "";
  for (var r = 0; r < size; r++) {
    for (var cc = 0; cc < size; cc++) {
      if (m[r][cc]) {
        rects +=
          '<rect x="' +
          (cc + margin) +
          '" y="' +
          (r + margin) +
          '" width="1" height="1"/>';
      }
    }
  }
  var svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' +
    dim +
    " " +
    dim +
    '" shape-rendering="crispEdges">' +
    '<rect width="' +
    dim +
    '" height="' +
    dim +
    '" fill="' +
    light +
    '"/>' +
    '<g fill="' +
    dark +
    '">' +
    rects +
    "</g></svg>";

  return "data:image/svg+xml;utf8," + encodeURIComponent(svg);
}

export { qrToSvgDataUri };
